import react from '../assets/react.png';
import html from '../assets/html.png';
import js from '../assets/javascript.png';
import sass from '../assets/sass.png';
import css from '../assets/css.png';
import php from '../assets/php.png';

export const SkillsData= [
    {
        image: react,
        about : 'REACT',
      },
    {
        image: html,
        about : 'HTML5',
      },
    {
        image: js,
        about : 'JAVASCRIPT',
      },
    {
        image: sass,
        about : 'SASS',
    },
    {
        image: css,
        about: 'CSS3',
      },
    {
        image: php,
        about : 'PHP',
      }
];


export const SchoolDetails = [
  "I have been working as a freelancer developer at Upwork in computer science related tasks. Programming in languages such as Java, PHP, C, React and more. ", 
    "Took an advanced course at Scrimba on React Development and modern practices",
   "I was among the students at ALX Africa who participated in web dev bootcamp, I learnt a lot including developing good UI and web securities among others",
   "",
   "I joined Maseno University and started my Computer Science journey since the I have learnt skills such as Database Systems Operating Systems, Information Systems, Computer Systems, Programming (pascal, Java, C/C++, Javascript, PHP), Web Design/Internet Computing/E-commerce, Data Structures and Algorithms, Intelligent Systems, Management Information Systems among other software and Hardware courses",
]